@if (isChangingAccount) {
  <ntw-loading-panel></ntw-loading-panel>
}

@if (!areAccountsLoading) {
  @if (canChangeContext) {
    <button #contextToggleButton type="button" class="context-toggle"
      [disabled]="isChangingAccount" [attr.aria-expanded]="isAccountSelectionVisible" (click)="toggle()">
      <span class="inline select-context">{{ selectedAccount?.CustomerName || ('navigationTopBar.selectContext' | translate) }}</span>
      <kendo-svg-icon class="select-context-arrow" [icon]="icons.chevrons.chevronDown" size="small"></kendo-svg-icon>
    </button>
  } @else {
    <p class="inline select-context">{{ selectedAccount?.CustomerName || contextData[0]?.CustomerName || ('navigationTopBar.selectContext' | translate) }}</p>
  }
}

@if (isAccountSelectionVisible && canChangeContext) {
  <ul #contextList class="select-context-list" [attr.aria-label]="'navigationTopBar.selectContext' | translate">
    @for (customer of contextData; track customer.AXCode) {
      <li>
        <button type="button" class="context-option"
          [class.context-option--selected]="selectedAccount?.AXCode === customer.AXCode"
          [attr.aria-current]="selectedAccount?.AXCode === customer.AXCode ? 'true' : null"
          (click)="selectCustomer(customer)">
          {{ customer.CustomerName }}
        </button>
      </li>
    }
  </ul>
}
